import _ from 'lodash';
import apolloClient from '@/store/apollo';

import PageGql from '@/store/graphql/queries/Page.gql';
import PagesPaginatedGql from '@/store/graphql/queries/PagesPaginated.gql';

export default {
    fetchPagesPaginated: (data) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, (entry) => filters.push(entry));

            apolloClient
                .query({
                    query: PagesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'date'),
                        direction: _.get(data, 'variables.direction', 'asc'),
                        filters,
                    },
                })
                .then(({ data }) => resolve(data.CP_PagesPaginated))
                .catch((err) => reject(err));
        }),
    fetchPage: (variables) => {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PageGql,
                    variables,
                })
                .then(({ data }) => resolve(data.CP_Page))
                .catch((err) => reject(err));
        });
    },
};
